import { useAppStateStore, useLeadStore } from "../../../../stores";

const validationProps = (prop) => {
  const { formSubmitted, isValid } = useAppStateStore.get();
  return { formSubmitted, isValid, [prop]: useLeadStore.get("consumer")[prop] };
};

const validationPropsVehicleOfInterest = (prop) => {
  const { formSubmitted, isValid } = useAppStateStore.get();
  return {
    formSubmitted,
    isValid,
    [prop]: useLeadStore.get("vehicleOfInterest")[prop],
  };
};

export default validationProps;
export { validationPropsVehicleOfInterest };
